var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center"},[(_vm.color === '')?_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}}):_c('div',{class:'spinner-border text-'+_vm.color,attrs:{"role":"status"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }